








import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LanguageSelector extends Vue {
  protected data () {
    return { langs: ['en', 'es'] }
  }
}
